import { put, takeLatest, call } from "redux-saga/effects";
import api from "~/services/apiNoAuth";
import { Types as SignUpTypes } from "./actions";
import { Types as AuthenticationTypes } from "../authentication/actions";
import { urlEncode } from "~/utils/tools";
import { variables } from "~/utils/variables";
import history from "~/routes/history";
import MESSAGES from "~/utils/messages";

export function* getCSRFToken() {
  try {
    const { data } = yield call(api.post, "/promo/geral/getCSRFToken");
    return data;
  } catch (err) {
    console.error("Error fetching CSRF token:", err);
    return null;
  }
}

export function* verifyEmail({ payload }) {
  payload.Device = navigator.userAgent;
  payload.ConnectHash = variables.connectHash;
  const payloadValues = urlEncode(payload);
  try {
    const { data } = yield call(
      api.post,
      "/engine/participante/email-existe",
      payloadValues
    );
    if (data?.sucesso) {
      yield put({
        type: SignUpTypes.VERIFY_EMAIL_SUCCESS,
        payload: data,
      });
    } else {
      yield put({ type: SignUpTypes.VERIFY_EMAIL_FAIL, payload: data });
    }
    return data;
  } catch (err) {
    yield put({
      type: SignUpTypes.VERIFY_EMAIL_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* sendSignupForm({ payload }) {
  try {
    payload.Device = navigator.userAgent;
    payload.ConnectHash = variables.connectHash;
    payload.Token = process.env.REACT_APP_PROMO_TOKEN;
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      api.post,
      "promo/participante/cadastrar",
      payloadValues
    );
    if (data?.sucesso) {
      yield put({
        type: SignUpTypes.SEND_SIGNUP_SUCCESS,
        payload: {
          userMail: payload.Email,
          userHash: data.ParticipanteHash,
        },
      });

      if (data?.recadastro) {
        
        yield put({
          type: AuthenticationTypes.SET_COMPLETE_SIGNUP,
          payload: data,
        });
        if (!data.DocumentoCrip){
          yield history.push({
            pathname: "/cadastre-se/passo-1/dados-pessoais",
            search: window.location.search,
          });
        }else if (!data?.Filhos?.length){
          yield history.push({
            pathname: "/cadastre-se/passo-1/bebe",
            search: window.location.search,
          });
        }else if (!data.Instagram){
          yield history.push({
            pathname: "/cadastre-se/passo-1/dados-contato",
            search: window.location.search,
          });
        }
        else{
          yield history.push({
            pathname: "/cadastro-promo",
            search: window.location.search,
          });
        }
      } else {
        yield history.push({
          pathname: "/verifique-seu-email",
          search: window.location.search,
        });
      }
    } else {
      yield put({ type: SignUpTypes.SEND_SIGNUP_FAIL, payload: data });
    }
  } catch (err) {
    yield put({
      type: SignUpTypes.SEND_SIGNUP_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* sendConfirmCode({ payload }) {
  const csrfToken = yield call(getCSRFToken);
  try {
    payload.Device = navigator.userAgent;
    payload.ConnectHash = variables.connectHash;
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      api.post,
      "engine/participante/validar-cadastro",
      payloadValues,
      { headers: { "X-CSRF-Token": csrfToken } }
    );
    if (data.sucesso) {
      yield put({
        type: SignUpTypes.SEND_CONFIRM_SUCCESS,
        payload: data,
      });
    } else {
      yield put({
        type: SignUpTypes.SEND_CONFIRM_FAIL,
        payload: data,
      });
    }
  } catch (err) {
    yield put({
      type: SignUpTypes.SEND_CONFIRM_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export function* resendConfirmEmail({ payload }) {
  try {
    payload.Device = navigator.userAgent;
    payload.ConnectHash = variables.connectHash;
    const payloadValues = urlEncode(payload);
    const { data } = yield call(
      api.post,
      "engine/participante/reenviar-email-validar-cadastro",
      payloadValues
    );
    if (data.sucesso) {
      yield put({
        type: SignUpTypes.RESEND_CONFIRM_SUCCESS,
        payload: data,
      });
    } else {
      yield put({
        type: SignUpTypes.RESEND_CONFIRM_FAIL,
        payload: data,
      });
    }
  } catch (err) {
    yield put({
      type: SignUpTypes.RESEND_CONFIRM_FAIL,
      payload: { msg: err || MESSAGES.genericError },
    });
  }
}

export default function* saga() {
  yield takeLatest(SignUpTypes.SEND_SIGNUP_FORM, sendSignupForm);
  yield takeLatest(SignUpTypes.SEND_CONFIRM_CODE, sendConfirmCode);
  yield takeLatest(SignUpTypes.RESEND_CONFIRM_EMAIL, resendConfirmEmail);
  yield takeLatest(SignUpTypes.VERIFY_EMAIL, verifyEmail);
}
